// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_4Sd","cls2":"TranslationModal-cls2_NI5 TranslationModal-cls1_4Sd"};